import {Controller} from "@hotwired/stimulus"

export class AlarmOrderFormController extends Controller {
	static targets = ["select", "simpleInfo", "detailInfo", "detail"]

	connect() {
		this.reconnect = this.reconnect.bind(this); // Ensure that `this` points back to our controller
		window.addEventListener('turbo:morph', this.reconnect);
		this.update({target: this.selectTarget})
	}

	update(e) {
		this.simpleInfoTarget.classList.toggle("d-none", e.target.value === "detailed")
		this.detailInfoTarget.classList.toggle("d-none", e.target.value !== "detailed")
		this.detailTargets.forEach(el => el.classList.toggle("invisible", e.target.value !== "detailed"))
	}


	disconnect() {
		window.removeEventListener('turbo:morph', this.reconnect);
	}

	reconnect() {
		this.update({target: this.selectTarget})
	}
}
